import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StorageService } from '../../core/services/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../core/services/login.service';
import { CommonService } from 'src/app/core/services/common.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-request-user-access',
  templateUrl: './request-user-access.component.html',
  styleUrls: ['./request-user-access.component.css']
})
export class RequestUserAccessComponent implements OnInit {
  public requestAccessForm!: FormGroup;
  public requestAccessErrResp!: string;
  isSubmitted: boolean = false;
  userDetails: any;
  isArabic!: boolean;
  isAccessRequested: boolean = false;
  userData: any;
  allowdKeys = [
    'backspace',
    'delete',
    'arrowleft',
    'arrowright',
    'arrowdown',
    'arrowup',
  ];
  fileToUpload: File | null = null;
  fileToUploadBase64: any;
  fileSize: any;
  fileName: any;
  showSizeErr: any;
  isFileUploaded!: any;
  fileUploadErr!: boolean;
  fileTypeErr!: boolean;
  ticketNumber!: string;
  createdTicketNumber!: string;
  allowedKeysAlphabet = [8, 9, 37, 38, 39, 40, 46, 189, 190, 222];
  disabledBtn: any;
  serverErr: any;
  modalRef!: BsModalRef;
  @ViewChild('attachment') fileInput!: ElementRef;
  incidentId: any;
  isViewMode: boolean = false;
  uploadedFile: any;
  uploadedFileName: any;
  uploadedFileType: any;
  caseType: string = 'User Access Request';

  constructor(private route: Router, public formBuilder: FormBuilder, private commonService: CommonService,
    private storageService: StorageService, private loginService: LoginService, private assessmentService: AssessmentService,
    private modalService: BsModalService, private activatedRoute: ActivatedRoute, private location: Location) {
    let details = this.activatedRoute.snapshot.paramMap.get('details');
    if (details) {
      this.incidentId = this.commonService.decryptUsingAES256(details);
    }
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.requestAccessForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      newUserEmail: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      mobile: ['', [Validators.required]],
      countrycode: ['', [Validators.required]],
      assessmentUnit: ['', [Validators.required]],
      resolutionComment: ['', []]
    });
    //console.log('this.userDetails', this.userDetails)
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    const rqstBody = { contactId: this.userDetails?.contactId };
    this.assessmentService.getUserData(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get user data in user profile: ', decryptedData);
      this.userData = JSON.parse(JSON.stringify(decryptedData));
      //console.log('user details in request user access: ', this.userData);
      if (!this.userData?.isActivate) {
        this.showDeactivationPopup();
      } else {
        this.requestAccessForm.patchValue({
          assessmentUnit: this.userData.assessmentUnit.name
        });
        this.requestAccessForm.controls['assessmentUnit'].disable();
      }
    });

    if (this.incidentId) {
      this.isViewMode = true;
      const detailsRqstBody =
      {
        contactguid: this.userDetails?.contactguid,
        assessmentunitguid: this.userDetails?.assessmentUnitValue,
        incidentId: this.incidentId,
        caseType: this.caseType

      }
      this.assessmentService.fetchCaseDetails(detailsRqstBody)
        .subscribe((data: any) => {
          let decryptedData = this.commonService.decryptUsingAES256(data?.data);
          //console.log("Case details user access request:", decryptedData);
          if (decryptedData?.caseDetails) {
            this.requestAccessForm.controls['firstName'].setValue(decryptedData?.caseDetails?.firstName);
            this.requestAccessForm.controls['firstName'].disable();
            this.requestAccessForm.controls['lastName'].setValue(decryptedData?.caseDetails?.lastName);
            this.requestAccessForm.controls['lastName'].disable();
            this.requestAccessForm.controls['newUserEmail'].setValue(decryptedData?.caseDetails?.emailId);
            this.requestAccessForm.controls['newUserEmail'].disable();
            this.requestAccessForm.controls['mobile'].setValue(decryptedData?.caseDetails?.contactNumber);
            this.requestAccessForm.controls['mobile'].disable();
            this.requestAccessForm.controls['countrycode'].setValue(decryptedData?.caseDetails?.countryCode);
            this.requestAccessForm.controls['countrycode'].disable();
            this.requestAccessForm.controls['resolutionComment'].setValue(decryptedData?.caseDetails?.resolutionComment);
            this.requestAccessForm.controls['resolutionComment'].disable();
            this.createdTicketNumber = decryptedData?.caseDetails?.ticketNumber;
          }
        });
      const rqstBodyForFiles = {
        responseguid: this.incidentId,
        type:"incident"
      }
      this.assessmentService.fetchUploadedFile(rqstBodyForFiles)
        .subscribe((data: any) => {
          let decryptedData = this.commonService.decryptUsingAES256(data?.data);
          //console.log("Case files user access:", decryptedData);

          let resp = JSON.parse(JSON.stringify(decryptedData));
          //console.log('finally files in request user access: ', resp);
          this.uploadedFile = resp?.documentbody;
          if (this.uploadedFile || resp?.filename) {
            this.uploadedFileName = resp?.filename;
            this.uploadedFileType = resp?.mimetype;
            //this.downloadFile(resp?.documentbody, resp?.mimetype, this.uploadedFileName);
          }
        })
    }

  }

  get comments() {
    return this.requestAccessForm.controls['resolutionComment'].value;
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  checkNumber(event: any) {
    if (
      !this.allowdKeys.includes(event.key?.toLowerCase()) &&
      isNaN(Number(event.key)) && event.which != 9
    ) {
      event.preventDefault();
      return;
    }
  }

  checkAlphabets(e: any) {
    // var Regexp = /[^a-zA-Z/,/\ ]/;
    var regex = new RegExp("^[ A-Za-z]*$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str) || this.allowedKeysAlphabet.includes(e.which) || e.key == "'" || e.key == '-' || e.key == '.') {
      return true;
    }
    e.preventDefault();
    return false;
  }

  onPaste(e: any) {
    e.preventDefault();
    return false;
  }

  requestAccess() {
    this.isSubmitted = true;
    if (this.requestAccessForm.valid && this.isFileUploaded) {
      const requestUserAccessData = {
        title: 'Request User Access',
        description: `Create user access for --- First Name: ${this.requestAccessForm.value.firstName}, Last Name: ${this.requestAccessForm.value.lastName}, Email ID: ${this.requestAccessForm.value.newUserEmail}, Contact No.: +${this.requestAccessForm.value.countrycode} ${this.requestAccessForm.value.mobile} and Assessment Entity: ${this.userData.assessmentUnit.name}`,
        contactId: this.userDetails.contactguid,
        caseType: 'User Access Request',
        firstname: this.requestAccessForm.value.firstName,
        lastname: this.requestAccessForm.value.lastName,
        email: this.requestAccessForm.value.newUserEmail,
        mobile: this.requestAccessForm.value.mobile,
        countrycode: this.requestAccessForm.value.countrycode,
        assessmentUnit: this.userData.assessmentUnit.value
      }
      //console.log(requestUserAccessData);
      this.disabledBtn = true;
      this.loginService.createCase(requestUserAccessData).subscribe((data: any) => {
        //console.log('request user access data: ', data);
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        if (decryptedData?.isCaseCreated === true) {
          let incidentId = decryptedData.incidentId;
          let ticketNumber = decryptedData.ticketNumber;
          this.callUploadFile(incidentId, ticketNumber);
        } else if (data?.error) {
          this.requestAccessErrResp = data?.error.errMsg;
          this.disabledBtn = false;
          window.scrollTo(0, 0);
        }
      }, (error: any) => {
        if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
          this.showDeactivationPopup();
        } else {
          this.serverErr = error?.body?.error;
        }
        this.disabledBtn = false;
        window.scrollTo(0, 0);
      });
    }
  }

  checkIfUserRequestExists() {
    this.isSubmitted = true;
    if (this.requestAccessForm.valid) {
      const rqstBodyContact = {
        userId: this.requestAccessForm.value.newUserEmail,
      }
      this.loginService.checkIfContactExists(rqstBodyContact).subscribe((contactdata: any) => {
        let decryptedContactData = this.commonService.decryptUsingAES256(contactdata?.data);
        if (!decryptedContactData?.isContactExist) {
          const request = {
            email: this.requestAccessForm.value.newUserEmail//"test"
          }
          this.loginService.checkIfUserRequestExists(request).subscribe((data: any) => {
            let decryptedData = this.commonService.decryptUsingAES256(data?.data);
            if (decryptedData.isUserAccessRequestExist) {
              //show already exist
              this.openErrorPopup(false, true);
            }
            else {
              this.requestAccess();
            }
          })
        }
        else {
          this.openErrorPopup(true, false);
        }
      })

    }
  }

  callUploadFile(incidentId: any, ticketNumber: any) {
    const rqstBody = {
      filename: this.fileName,
      documentBody: this.fileToUploadBase64,
      subjectId: ticketNumber,
      responseguid: incidentId,
      notesType: 'cases'
    }
    //console.log(rqstBody);
    this.disabledBtn = true;
    this.assessmentService.uploadFileToServer(rqstBody).subscribe((data4: any) => {
      let decryptedData3 = this.commonService.decryptUsingAES256(data4?.data);
      //console.log(decryptedData3);
      if (decryptedData3?.isUploaded === true) {
        this.fileUploadErr = false;
        this.isSubmitted = false;
        this.isAccessRequested = true;
        this.ticketNumber = ticketNumber;
        this.requestAccessForm.reset();
        this.requestAccessForm.patchValue({
          assessmentUnit: this.userData.assessmentUnit.name
        });
        this.fileInput.nativeElement.value = "";
        this.fileToUpload = null;
        this.fileToUploadBase64 = undefined;
        this.fileSize = undefined;
        this.fileName = undefined;
        this.showSizeErr = undefined;
        this.isFileUploaded = undefined;
        this.fileUploadErr = false;
        this.fileTypeErr = false;
        this.disabledBtn = false;
        // setTimeout(() => {
        //   this.isAccessRequested = false;
        // }, 10000);

      } else {
        this.fileUploadErr = true;
        this.isFileUploaded = false;
        this.disabledBtn = false;
      }
      window.scrollTo(0, 0);
    }, (error: any) => {
      this.serverErr = error?.body?.error;
      this.disabledBtn = false;
      window.scrollTo(0, 0);
    });
  }

  handleFileInput(evt: any) {
    this.isFileUploaded = undefined;
    let files = evt.target.files;
    this.fileToUpload = files[0];
    //console.log(files[0])
    let ext = files[0]?.name.split('.').pop();
    if (ext == 'doc' || ext == 'docx' || ext == 'pdf' || ext == 'txt'|| ext == 'jpg' || ext == 'jpeg' || ext == 'png') {
      this.fileName = files[0]?.name;
      this.fileSize = files[0]?.size;
      //console.log('filename: ', this.fileName);
      this.fileTypeErr = false;
      this.onFileUpload();

    } else {
      this.isFileUploaded = false;
      this.fileTypeErr = true;
    }
  }

  onFileUpload() {
  if (this.fileSize > 20 * 1024 * 1024) {
    this.showSizeErr = true;
    this.isFileUploaded = false;
  } else if (this.fileToUpload) {  // <--- null check added here
    this.showSizeErr = false;
    this.commonService.fileToBase64(this.fileToUpload).then(result => {
      // console.log('result base 64: ', result);
      this.fileToUploadBase64 = result;
      this.isFileUploaded = true;
    });
  } else {
    console.error('No file selected to upload.');
    this.isFileUploaded = false;
  }
}
  handleFileLinkClick() {
    this.downloadFile(this.uploadedFile, this.uploadedFileType, this.uploadedFileName);
  }
  downloadFile(linkSource: any, fileType: any, fileName: any) {
    const downloadLink = document.createElement('a');
    linkSource = 'data:' + fileType + ';base64,' + linkSource;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  goToLastPage() {
    this.location.back();
  }

  openErrorPopup(isContactExists: boolean, isRequestExists: boolean) {
    let message = '';
    if (this.isArabic) {
      if (isContactExists) {
        message = 'جهة اتصال بنفس معرف البريد الإلكتروني موجودة بالفعل في النظام';
      }
      else if (isRequestExists) {
        message = 'لقد تم بالفعل رفع طلب وصول المستخدم لجهة الاتصال هذه بنفس معرف البريد الإلكتروني';
      }
    } else {
      if (isContactExists) {
        message = 'A contact with same email ID already exists in the system'
      }
      else if (isRequestExists) {
        message = 'An user access request has already been raised for this contact with same email ID';
      }
    }

    const initialState = {
      message: message,
      redirectTo: '',
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { initialState });
  }
}
